import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import OrderBookDEXHero from "./OrderBookDEXHero";
import WhatIsAnOrder from "./WhatIsAnOrder";
import OrderMatching from "./OrderMatching";
import BuildARobust from "./BuildARobust";
import TraditionalOrder from "./TraditionalOrder";
import BlockchainExpertise from "../../AMM DEX/BlockchainExpertise";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function OrderBookDEX() {
  return (
    <div>
      <Header />
      <OrderBookDEXHero />
      <WhatIsAnOrder />
      <OrderMatching />
      <BuildARobust />
      <TraditionalOrder />
      {/* <BlockchainExpertise /> */}
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default OrderBookDEX;
